// UserContactTemplateコンポーネントをインポート
// ユーザー向けの「問い合わせ」ページ用テンプレートとして使用
import UserContactTemplate from "../templates/UserContactTemplate";

/**
 * UserContactPageコンポーネント
 * ユーザー向けの「問い合わせ」ページを表示するためのコンポーネント
 * UserContactTemplateを利用して問い合わせ画面を構築
 */
const UserContactPage = () => {

    // 問い合わせページテンプレートをレンダリング
    // 特別なプロパティを渡さず、UserContactTemplateをそのまま利用
    return (
        <UserContactTemplate />
    );
}

// UserContactPageコンポーネントをデフォルトエクスポート
// 他のファイルからこのコンポーネントをインポートして利用可能にする
export default UserContactPage;
